module.exports = __webpack_public_path__ + "static/media/BG_zigouigoui1.73d05fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/BG_zigouigoui1.png
// module id = 247
// module chunks = 0